/** The arcade palette (docs/spec/04 §1): twenty saturated colours on black. */

export const PALETTE: readonly string[] = [
  '#000000', // 0 black
  '#f4f4f4', // 1 white
  '#f02828', // 2 red
  '#ff9020', // 3 orange
  '#ffe040', // 4 yellow
  '#80f040', // 5 lime
  '#18b040', // 6 green
  '#30e0e8', // 7 cyan
  '#40a0ff', // 8 sky
  '#2040e0', // 9 blue
  '#3020a0', // 10 indigo
  '#a040f0', // 11 purple
  '#f040c8', // 12 magenta
  '#ff90b0', // 13 pink
  '#9098a8', // 14 grey
  '#485060', // 15 dark grey
  '#101838', // 16 navy
  '#a05820', // 17 brown
  '#108890', // 18 teal
  '#d0a020', // 19 gold
];

export const BLACK = 0;
export const WHITE = 1;
export const RED = 2;
export const ORANGE = 3;
export const YELLOW = 4;
export const LIME = 5;
export const GREEN = 6;
export const CYAN = 7;
export const SKY = 8;
export const BLUE = 9;
export const INDIGO = 10;
export const PURPLE = 11;
export const MAGENTA = 12;
export const PINK = 13;
export const GREY = 14;
export const DARK_GREY = 15;
export const NAVY = 16;
export const BROWN = 17;
export const TEAL = 18;
export const GOLD = 19;

export function colour(index: number): string {
  return PALETTE[index] ?? '#000000';
}

/** [r, g, b] 0-255. */
export function rgb(index: number): [number, number, number] {
  const hex = colour(index);
  return [Number.parseInt(hex.slice(1, 3), 16), Number.parseInt(hex.slice(3, 5), 16), Number.parseInt(hex.slice(5, 7), 16)];
}
